<template>
<div :id="id">
  <svg>
    <g class="angle"></g>
    <g class="text-angle"></g>
    <text class="center-text"></text>
    <text class="center-text-desc"></text>
  </svg>
</div>
</template>

<script>
import $d3Chart from "@/utils/chart";

export default {
  name: "DonutChart",
  created() {
    document.addEventListener('visibilitychange', this.visibilityChange, false);
  },
  props: {
    id: {
      type: String,
      default: "#chart-area"
    },
    data: {
      type: Array,
      default: null
    },
    size: {
      type: Number,
      default: 250
    },
    colors: {
      type: Array,
      default: null,
    },
    stroke: {
      type: String,
      default: "white"
    },
    strokeWidth: {
      type: Number,
      default: 3
    },
    centerText: {
      type: String,
      default: ""
    },
    centerDesc: {
      type: String,
      default: ""
    }
  },
  methods: {
    renderChart() {
      $d3Chart.donut(this.data, {
        area: `#${this.id}`,
        name: d => d.label,
        value: d => d.value,
        title: d => d.rate,
        width: this.size,
        height: this.size,
        stroke: this.stroke,
        strokeWidth: this.strokeWidth,
        centerDesc: this.centerDesc,
        centerText: this.centerText,
        colors: this.colors
      })
    },
    visibilityChange(e) {
      // Render lai chart khi tab active
      if (!document.hidden) {
        this.renderChart()
      }
    }
  },
  watch: {
    data() {
      // Khi tab active moi render chart
      if (!document.hidden) {
        this.renderChart()
      }
    }
  }
}
</script>

<style scoped>

</style>